import { render, staticRenderFns } from "./WaterMarkSwitch.vue?vue&type=template&id=74e6f98e&scoped=true"
import script from "./WaterMarkSwitch.vue?vue&type=script&lang=js"
export * from "./WaterMarkSwitch.vue?vue&type=script&lang=js"
import style0 from "./WaterMarkSwitch.vue?vue&type=style&index=0&id=74e6f98e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e6f98e",
  null
  
)

export default component.exports